import React, { Component } from 'react'
import Style from './UpdateOrganization.module.css'
import { connect } from 'react-redux'
import { setError, unSetStatusCode, updateUser } from '../store/entities/customers'
import { setNewToken } from '../store/entities/user'
// import jwt_decode from "jwt-decode";
import ModalPopup from './common/ModalPopup'
// import Modal from 'react-bootstrap/Modal'
import BackIcon from '../assets/backButton.svg'
import ConfirmPopup from './common/popover/confirmPopup'
// import {CookieUtils, setcookie} from '../utilities/cookies'
import { validateAlphaNumerics } from '../utilities/vaildations' 


class UpdateAdmin extends Component {

    constructor (props) {
        super(props);
        this.state = {
            id: '',
            isActive: false,
            firstName: '',
            lastName: '',
            email:'',
            showConfirmBox:false,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.customerFlag !== this.props.customerFlag) {
            if (this.props.customerFlag) {
                this.props.setNewToken()
            }
        }
    }

    handleModalClick = () => {
        this.props.history.push({ pathname: '/tenant-admin', state: { tab: 'Organization Management' } })
    }

    componentDidMount() {
        if(this.props.location.state.adminData) {
            let firstName = this.props.location.state.adminData.displayName ? this.props.location.state.adminData.displayName.split(' ').slice(0, 1).join(' ') : ''
            let lastName = this.props.location.state.adminData.displayName ? this.props.location.state.adminData.displayName.split(' ').slice(1).join(' ') : ''         
            this.setState({
                id: this.props.location.state.adminData.uid,
                firstName,
                lastName,
                email: this.props.location.state.adminData.email
            })
        }
    }

    handleChange = (event) => {
        const value = event.target.value
        this.setState({    
            [event.target.name]: value
        })
    }

    handleUpdate = (e) => {
        e.preventDefault();
        if(this.validateFields()) {
            let body = {
                "id": this.state.id,
                "firstName": this.state.firstName,
                "lastName": this.state.lastName,
                "email": this.state.email,
            }
            this.props.updateAdmin(body, 'PixmAdmin');
        }
        
    }

    handleClick = () => {
        this.props.history.push({ pathname: '/advanced-settings', state: { tab: 'Pixm Admin Management' } })
    }

    validateFields = () => {
        let isValid = true;
        let { firstName, lastName, email } = this.state;
        if(firstName.length > 0 && !validateAlphaNumerics(firstName) || firstName.length > 50) {
            let error = "First name should only be alphanumeric and not more than 50 characters"
            isValid = false;
            this.props.setError(error)
        } 

        if(lastName.length > 0 && !validateAlphaNumerics(lastName) || lastName.length > 50) {
            let error = "Last name should only be alphanumeric and not more than 50 characters"
            isValid = false;
            this.props.setError(error)
        }

        // if(email === '') {
        //     let error = "Email is required."
        //     isValid = false;
        //     this.props.setError(error)
        // }

        // if(!validateEmail(email)){
        //     let error = "Please enter a proper email id."
        //     isValid = false;
        //     this.props.setError(error)
        // }

        return isValid;
    }

    
    handleClose = () => {
        this.props.unSetStatusCode();
        if(this.props.statusCode === 200){
            this.props.history.push({ pathname: '/advanced-settings', state: { tab: 'Pixm Admin Management' } })
        }
    }

    render() {
        const {showConfirmBox} = this.state;

        return (
            <React.Fragment>
            <div className={'px-5 mt-4'}>
                <div className={`${Style.headerBg} px-5 d-flex align-items-center justify-content-between`}>
                    <div onClick={this.handleClick} style={{cursor: 'pointer'}}>
                        <img style={{ height: '1.5vw' }} src={BackIcon} alt={'back-icon'} />
                        Return to Admin Management
                    </div>
                </div>
                <div className={`${Style.accountFont} mt-5`}>
                    Admin Info
                </div>
                <div className={`mt-4 d-flex w-100`}>
                    <div className={`${Style.containerStyle} px-4 w-50`}>
                        <div className={`${Style.textStyle} pt-4`}>
                        Admin Details
                        </div>
                        <div className={'mt-3 d-flex flex-column'}>
                            <input defaultValue={this.state.firstName} value={this.state.firstName} name='firstName' placeholder={'First Name*'} className={`${Style.inputStyle} focus-none mt-2`} onChange={this.handleChange} />
                            <input defaultValue={this.state.lastName} value={this.state.lastName} name='lastName' placeholder={'Last Name*'} className={`${Style.inputStyle} focus-none mt-2`} onChange={this.handleChange} />
                            <input defaultValue={this.state.email} value={this.state.email} name='email' placeholder={'Email'} className={`${Style.inputStyle} focus-none mt-2`} disabled/>
                        </div>
                        <div className={`${Style.border} `} /> 
                        <div className={`py-4`}>
                            <button onClick={(e) => this.handleUpdate(e)} className={`${Style.submitButton} focus-none`}>Update Admin Info</button>
                            <button onClick={this.handleClick} className={`${Style.cancelButton} ml-3 focus-none`}>Cancel</button>
                        </div>
                    </div>
                </div>
                {this.props.statusCode && (
                    <ConfirmPopup
                    details={{
                    icon: '',
                    type: this.props.statusCode === 200 ? 'success':'error',
                    title: this.props.statusCode === 200 ? 'Admin Updated Successfully':'Admin could not be updated.',
                    description: this.props.userMsg,
                    buttons: 'O',
                    }}
                    onCloseClick={this.handleClose} />
                )}            
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    // customerFlag: state.entities.customers.createCustomerFlag,
    // userToken: state.entities.user.token,
    // refreshToken: state.entities.user.refreshToken,
    userMsg: state.entities.customers.userMsg,
    statusCode: state.entities.customers.statusCode,
    loading: state.entities.customers.loading,
})

const mapDispatchToProps = (dispatch) => ({
    // deleteCustomer: (customerId) => dispatch(deleteCustomer(customerId)),
    // updateSelectedCustomer: (customerId, body) => dispatch(updateSelectedCustomer(customerId, body)),
    setNewToken: () => dispatch(setNewToken()),
    unSetStatusCode: () => dispatch(unSetStatusCode()),
    setError: (error) => dispatch(setError(error)),
    updateAdmin: (body, roleType) => dispatch(updateUser(body, roleType)),
  })
  
  export default connect(mapStateToProps, mapDispatchToProps)(UpdateAdmin)